import AxiosInstance from "./api";

export const UserService = {
  getAll: async (payload) => {
    const query = new URLSearchParams(payload);
    return await AxiosInstance.get("/private/user?" + query?.toString());
  },
  getById: async (id) => {
    return await AxiosInstance.get("/private/user/" + id);
  },
  createUserAdmin: async (payload) => {
    return await AxiosInstance.post("/admin/user/create-user", payload);
  },
  createUserSuperAdmin: async (payload) => {
    return await AxiosInstance.post("/super-admin/user/create-user", payload);
  },
  update: async (id, payload) => {
    return await AxiosInstance.patch("/private/user/" + id, payload);
  },
  delete: async (id) => {
    return await AxiosInstance.delete("/private/user/" + id);
  },
};
